import { Role } from '../models/role';
import { AuthService } from '../../login/services/auth.service';
import { OnInit, EventEmitter, OnChanges } from '@angular/core';
import { User } from "../../shared/models/user";
import { UserService } from "../../shared/services/user.service";
import { SelectComponent } from 'ng-mdb-pro/pro';
var UserSelectorComponent = /** @class */ (function () {
    function UserSelectorComponent(userService, authService) {
        this.userService = userService;
        this.authService = authService;
        this.selected = new EventEmitter();
        this.users = [];
    }
    UserSelectorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authService.getCurrentUser().then(function (currentUser) {
            var getUsers = Promise.resolve([currentUser]);
            if (currentUser.role <= Role.Admin) {
                getUsers = _this.userService.getUsers();
            }
            getUsers.then(function (users) {
                var activeUsers = users.filter(function (u) { return u.enabled; }); // only display activated users.
                if (_this.filter) {
                    _this.users = activeUsers.filter(_this.filter);
                }
                else {
                    _this.users = activeUsers;
                }
                _this.selectOptions = [{ label: "None", value: null, selected: false }].concat(activeUsers.map(function (u) {
                    var selected = _this.user ? _this.user.id == u.id : false;
                    var result = { label: u.getDisplayName(), value: u.id, selected: selected };
                    return result;
                }));
                // TODO: stephen I would rather use ngModel but none of that is working
                // we're going to bruteforce it for now.
                if (_this.user) {
                    _this.select.select(_this.user.id.toString());
                }
            });
        });
    };
    UserSelectorComponent.prototype.ngAfterContentInit = function () {
    };
    UserSelectorComponent.prototype.ngOnChanges = function () {
    };
    Object.defineProperty(UserSelectorComponent.prototype, "selectedUserId", {
        get: function () {
            return this._selectedUserId;
        },
        set: function (v) {
            this._selectedUserId = v;
        },
        enumerable: true,
        configurable: true
    });
    UserSelectorComponent.prototype.selectUser = function (selected) {
        var intVal = +selected.value;
        var user = this.users.find(function (u) { return u.id == intVal; });
        this.selected.emit(user);
    };
    return UserSelectorComponent;
}());
export { UserSelectorComponent };



// WEBPACK FOOTER //
// ./src/app/shared/user-selector/user-selector.component.ts.pre-build-optimizer.js